import { render, staticRenderFns } from "./ProfileGamesElement.vue?vue&type=template&id=6120fbec&scoped=true"
import script from "./ProfileGamesElement.vue?vue&type=script&lang=js"
export * from "./ProfileGamesElement.vue?vue&type=script&lang=js"
import style0 from "./ProfileGamesElement.vue?vue&type=style&index=0&id=6120fbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120fbec",
  null
  
)

export default component.exports